import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-10 mb-10" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Nome do Modelo/Carro:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, "Sub-filtro do cardápio ex: Gol G5 ou Gol G6", -1)
const _hoisted_6 = { class: "d-flex w-100 justify-content-end" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save text-white" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1)

import { reactive, ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";
import { RevisionDetailView } from "@/models/CardapioModel";
import { updateCar } from "@/services/CardapioService";
import Swal from "sweetalert2/dist/sweetalert2.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormCar',
  props: {
    updateCar: {}
  },
  setup(__props: any) {

const props = __props;

const ruleFormRef = ref();
const emitter = useEmitter();
const { showTimeAlert } = useAlert();
const codConcessionaria = localStorage.getItem("filtroConcessionaria");
const store = useStore();
const form = reactive({
  car: "",
});
const loading = reactive({
  submit: false,
  optionDescription: false,
});
const rules = reactive({
  car: [
    {
      required: true,
      message: "Por favor, digite um nome.",
      trigger: "blur",
    },
  ],
});

watch(
  () => props.updateCar,
  (newValue) => {
    if (newValue) {
      console.log(newValue);
      form.car = newValue.car;
    }
  },
  { deep: true, immediate: true }
);

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      Swal.fire({
        title: "Deseja fazer alterações no Veiculo?",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        text: "As alterações serão refletidas no app assim que forem salvas.",
      }).then((result) => {
        if (result.isConfirmed) {
          handleSubmit();
        } else if (result.isDenied) {
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

const handleSubmit = async () => {
  if (codConcessionaria && typeof codConcessionaria == "string") {
    const payload = {
      ...form,
      codConcessionaria: codConcessionaria,
      currentCar: props.updateCar.car,
      grupoExibicao: props.updateCar.family,
    };
    loading.submit = true;

    await updateCar(payload)
      .then((r) => {
        showTimeAlert(r.message);
        emitter.emit("update-family", {});
      })
      .catch(() => {
        showTimeAlert("Não foi possível completar a solicitação", "error");
      })
      .finally(() => (loading.submit = false));
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: form,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "auto",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createVNode(_component_el_form_item, { prop: "car" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.car,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.car) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm background_btn_1 text-white",
              id: "kt_button_1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (submitForm(ruleFormRef.value))),
              disabled: loading.submit
            }, [
              (!loading.submit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(" Salvar ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" Aguarde... ")
                  ]))
            ], 8, _hoisted_7)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})